import React, { useState } from 'react'
import {
  IconButton,
  CopyToClipboardIcon,
  CheckmarkIcon,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import ReactTooltip from 'react-tooltip'
import { recordDynamicEvent } from '../analytics/utils/record-dynamic-event'

export const CopyToClipboardButtonBanner = ({
  props,
  infoToCopy,
  analitycsOrigen,
  onCopyClick,
  isDisabled,
  className = '',
}) => {
  const [isClick, setIsClick] = useState(false)

  const CopyClickHandler = async (event) => {
    recordDynamicEvent(analitycsOrigen + ',click,copy-to-clipboard-banner')
    const valueToCopy = infoToCopy || (await onCopyClick(event))

    if (valueToCopy) {
      await navigator.clipboard.writeText(valueToCopy)
      setIsClick(true)
      setTimeout(() => setIsClick(false), 3000)
    }
  }

  return (
    <>
      <IconButton
        style={{ padding: '0px', marginLeft: '10px' }}
        className={className}
        {...props}
        size="xs"
        data-for={analitycsOrigen}
        data-tip
        buttonType="tertiary"
        svgIconComponent={CopyToClipboardIcon}
        name="copy-to-clipboard-banner"
        onClick={CopyClickHandler}
        disabled={isDisabled}
        onMouseOver={({ target }) => (target.style.color = '#0070ba')}
        onMouseOut={({ target }) => (target.style.color = '#545d68')}
      />
      <ReactTooltip
        className="dev_dash__tool-tip-copy-banner"
        id={analitycsOrigen}
        place="top"
        type="light"
        effect="solid"
      >
        {isClick === true ? (
          <>
            <CheckmarkIcon size="sm" color="sysColorSuccessMain" />
            <Message id="validate.copy.clipboard.copied" />
          </>
        ) : (
          <Message id="validate.copy.clipboard.copytoclipboard" />
        )}
      </ReactTooltip>
    </>
  )
}
